export default function (scheduler) {
	function getStorageKey() {
		return (scheduler._obj.id || "scheduler") + "_settings";
	}

	const dateToString = scheduler.date.date_to_str("%Y-%m-%d %H:%i");
	const stringToDate = scheduler.date.str_to_date("%Y-%m-%d %H:%i");


	function safeLocalStorageGet(key) {
		try {
			return window.localStorage.getItem(key);
		} catch (e) {
			return null;
		}
	}

	function safeLocalStorageSet(key, value) {
		try {
			window.localStorage.setItem(key, value);
			return true;
		} catch (e) {
			return false;
		}
	}

	function readStoredState() {
		const storageKey = getStorageKey();
		const raw = safeLocalStorageGet(storageKey);
		if (!raw) {
			return { date: null, mode: null };
		}

		let parsed;
		try {
			parsed = JSON.parse(raw);
		} catch (e) {
			return { date: null, mode: null };
		}

		if (!parsed || typeof parsed !== "object") {
			return { date: null, mode: null };
		}

		let parsedDate = null;
		if (typeof parsed.date === "string" && parsed.date.length > 0) {
			try {
				parsedDate = stringToDate(parsed.date);
				if (isNaN(+parsedDate)) {
					parsedDate = null;
				}
			} catch (e) {
				parsedDate = null;
			}
		}

		const parsedMode = typeof parsed.mode === "string" ? parsed.mode : null;

		return { date: parsedDate, mode: parsedMode };
	}

	function urlHasExplicitNavigation() {
		if (!scheduler._get_url_nav) {
			return false;
		}

		const urlState = scheduler._get_url_nav();
		if (!urlState) {
			return false;
		}

		if (urlState.date || urlState.mode || urlState.event) {
			return true;
		}

		return false;
	}

	const originalGetInitialState = scheduler._getInitialState;

	scheduler._getInitialState = function (provided) {
		const baseState = originalGetInitialState.call(this, provided);

		if (urlHasExplicitNavigation()) {
			return baseState;
		}

		const storedState = readStoredState();

		const nextState = {
			date: baseState.date,
			mode: baseState.mode
		};

		if (storedState.date) {
			nextState.date = storedState.date;
		}

		if (storedState.mode) {
			try {
				if (this.isViewExists(storedState.mode)) {
					nextState.mode = storedState.mode;
				}
			} catch (e) {
				// ignore
			}
		}

		return nextState;
	};

	scheduler.attachEvent("onViewChange", function (newMode, newDate) {
		const storageKey = getStorageKey();

		const payload = {
			date: dateToString(newDate),
			mode: newMode
		};

		safeLocalStorageSet(storageKey, JSON.stringify(payload));
		return true;
	});
}
